<!-- Menu Content -->
<div class="w-full"
     [class.field]="formField">
  @if (tooltipLabel) {
    <p-splitButton
      label="{{ label }}"
      [title]="tooltipLabel"
      [model]="items"
      class="h-full"
      menuStyleClass="{{ menuClass }}"
      (onClick)="buttonClick.emit($event)">
      <ng-template pTemplate="content">
        <span class="flex flex-row column-gap-2 align-items-center font-bold">
          <i [class]="iconClass"></i>
          <i [class]="iconClassAfter"></i>
        </span>
      </ng-template>
    </p-splitButton>
  }
  @if (!tooltipLabel) {
    <p-splitButton
      label="{{ label }}"
      [model]="items"
      class="h-full"
      menuStyleClass="{{ menuClass }}"
      (onClick)="buttonClick.emit($event)">
      <ng-template pTemplate="content">
        <span class="flex flex-row column-gap-2 align-items-center font-bold">
          <i [class]="iconClass"></i>
          <i [class]="iconClassAfter"></i>
        </span>
      </ng-template>
    </p-splitButton>
  }
</div>